import { useEffect, useState } from 'react';
import { getIsCMA, getIsUvpaa } from '@paypalcorp/identitywebcomponents';

// Internal modules
import { isDevicePasskeyEligible } from '../globals';
import { appStore } from '@/store';

export const usePasskeyAvailable = (): boolean => {
  const [isBrowserEligible, setIsBrowserEligible] = useState(false);

  useEffect(() => {
    // UVPAA - UserVerifyingPlatformAuthenticatorAvailable
    // CMA - ConditionalMediationAvailable
    Promise.all([getIsUvpaa(), getIsCMA()]).then(([isUVPAA, isCMA]) => {
      if (isUVPAA && isCMA) {
        setIsBrowserEligible(true);
      }
    });
  }, []);

  // Device eligibility is based on user agent - OS and browser version compatibility for passkey
  // Browser eligibility is based on window object check for UVPAA and CMA functions
  // UVPAA - UserVerifyingPlatformAuthenticatorAvailable
  // CMA - ConditionalMediationAvailable
  const isPasskeyAvailable = isDevicePasskeyEligible() && isBrowserEligible;

  // Update only if the value is true, as the default is set to false
  if (isPasskeyAvailable) {
    appStore.getActions().user.setIsPasskeyAvailable(true);
  }

  return isPasskeyAvailable;
};
